/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Patchy_Extra_Mongoose_FadeInputs */

const en_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const id_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const ms_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const ca_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obre`)
};

const cs_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít`)
};

const da_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åbn`)
};

const de_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

const et_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ava`)
};

const es_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const fr_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

const hr_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otvori`)
};

const it_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri`)
};

const lv_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atvērt`)
};

const lt_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atidaryti`)
};

const hu_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megnyitás`)
};

const nl_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const nb_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åpne`)
};

const pl_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz`)
};

const pt_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const ro_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deschide`)
};

const sk_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otvoriť`)
};

const sl_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpri`)
};

const fi_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaa`)
};

const sv_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öppna`)
};

const vi_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở`)
};

const tr_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açık`)
};

const el_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Άνοιγμα`)
};

const bg_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отваряне`)
};

const ru_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть`)
};

const sr_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отвори`)
};

const uk_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкриті`)
};

const ka_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გახსნა`)
};

const hi_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोलें`)
};

const th_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด`)
};

const ko_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`열기`)
};

const zh_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开`)
};

const zh_tw_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開`)
};

const ja_patchy_extra_mongoose_fade = /** @type {(inputs: Patchy_Extra_Mongoose_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Patchy_Extra_Mongoose_FadeInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const patchy_extra_mongoose_fade = /** @type {((inputs?: Patchy_Extra_Mongoose_FadeInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Patchy_Extra_Mongoose_FadeInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_patchy_extra_mongoose_fade(inputs)
	if (locale === "ms") return ms_patchy_extra_mongoose_fade(inputs)
	if (locale === "ca") return ca_patchy_extra_mongoose_fade(inputs)
	if (locale === "cs") return cs_patchy_extra_mongoose_fade(inputs)
	if (locale === "da") return da_patchy_extra_mongoose_fade(inputs)
	if (locale === "de") return de_patchy_extra_mongoose_fade(inputs)
	if (locale === "et") return et_patchy_extra_mongoose_fade(inputs)
	if (locale === "es") return es_patchy_extra_mongoose_fade(inputs)
	if (locale === "fr") return fr_patchy_extra_mongoose_fade(inputs)
	if (locale === "hr") return hr_patchy_extra_mongoose_fade(inputs)
	if (locale === "it") return it_patchy_extra_mongoose_fade(inputs)
	if (locale === "lv") return lv_patchy_extra_mongoose_fade(inputs)
	if (locale === "lt") return lt_patchy_extra_mongoose_fade(inputs)
	if (locale === "hu") return hu_patchy_extra_mongoose_fade(inputs)
	if (locale === "nl") return nl_patchy_extra_mongoose_fade(inputs)
	if (locale === "nb") return nb_patchy_extra_mongoose_fade(inputs)
	if (locale === "pl") return pl_patchy_extra_mongoose_fade(inputs)
	if (locale === "pt") return pt_patchy_extra_mongoose_fade(inputs)
	if (locale === "ro") return ro_patchy_extra_mongoose_fade(inputs)
	if (locale === "sk") return sk_patchy_extra_mongoose_fade(inputs)
	if (locale === "sl") return sl_patchy_extra_mongoose_fade(inputs)
	if (locale === "fi") return fi_patchy_extra_mongoose_fade(inputs)
	if (locale === "sv") return sv_patchy_extra_mongoose_fade(inputs)
	if (locale === "vi") return vi_patchy_extra_mongoose_fade(inputs)
	if (locale === "tr") return tr_patchy_extra_mongoose_fade(inputs)
	if (locale === "el") return el_patchy_extra_mongoose_fade(inputs)
	if (locale === "bg") return bg_patchy_extra_mongoose_fade(inputs)
	if (locale === "ru") return ru_patchy_extra_mongoose_fade(inputs)
	if (locale === "sr") return sr_patchy_extra_mongoose_fade(inputs)
	if (locale === "uk") return uk_patchy_extra_mongoose_fade(inputs)
	if (locale === "ka") return ka_patchy_extra_mongoose_fade(inputs)
	if (locale === "hi") return hi_patchy_extra_mongoose_fade(inputs)
	if (locale === "th") return th_patchy_extra_mongoose_fade(inputs)
	if (locale === "ko") return ko_patchy_extra_mongoose_fade(inputs)
	if (locale === "zh") return zh_patchy_extra_mongoose_fade(inputs)
	if (locale === "zh-tw") return zh_tw_patchy_extra_mongoose_fade(inputs)
	if (locale === "ja") return ja_patchy_extra_mongoose_fade(inputs)
	return en_patchy_extra_mongoose_fade(inputs)
});